import { render, staticRenderFns } from "./ValidationErrors.vue?vue&type=template&id=8e59f22a&scoped=true&"
import script from "./ValidationErrors.vue?vue&type=script&lang=js&"
export * from "./ValidationErrors.vue?vue&type=script&lang=js&"
import style0 from "./ValidationErrors.vue?vue&type=style&index=0&id=8e59f22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e59f22a",
  null
  
)

export default component.exports